<template>
	<div class="sd_content_banner">
		<el-carousel height="380px" ref="carousel" :interval="5000">
			<el-carousel-item v-for="(item,index) in infoList" :key="index" name="index">
				<el-image class="sd_content_img" :src="item.news_pic" fit="cover" @click="showDetail(item)"></el-image>
				<div class="floatDiv" @click="showDetail(item)">
					<p>{{item.news_title}}</p>
					<!-- 设置自定义悬浮指示器 -->
					<div class="floatDash">
						<p v-for="(item,key) in infoList" :key="key" @mouseenter="listTab(key)"
							:class="[key === index ? 'setOpacity':'normalOpacity']">
						</p>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	import {getWebRecommendNews} from "../../../api/moudles/home";

	const infoList = [
	]

	export default {
		data() {
			return {
				infoList
			}
		},

		created() {

			this.getNews()
		},

		methods: {

			getNews(){
				getWebRecommendNews({
					data: {
						column_code:'9908861D-BC71-1917-CD4B-BE44D3BFE383',
					},
					success: (res) => {

						console.log(res)

						this.infoList = res.data

					}

				})
			},

			// 更换指示器
			listTab(key) {
				this.$refs.carousel.setActiveItem(key)
			},
			// 展示nav详情
			showDetail(item) {
				console.log('item', item)
				this.$router.push(`/detail/${item.id}`)
			},
		}
	}
</script>

<style scoped>
	.sd_content_img {
		width: 100%;
		height: 100%;
		transition: all .3s;
	}
	.sd_content_img:hover{
		cursor: pointer;
		transform: scale(1.1);
	}

	.sd_content_banner {
		width: 600px;
		height: 380px;
		border-radius: 8px;
		overflow: hidden;
	}

	.floatDiv {
		position: absolute;
		bottom: 10px;
		left: 20px;
		width: calc(100% - 20px);
		height: 28px;
		line-height: 28px;
		font-size: 14px;
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		color: #ffffff;
		align-items: center;
	}

	.floatDash p {
		display: block;
		background-color: #fff;
		border-radius: 50%;
		width: 12px;
		margin: 0 10px;
		height: 12px;
	}

	.floatDash p:hover {
		opacity: 1 !important;
	}

	.floatSpan {
		position: absolute;
		top: 50px;
		left: 20px;
		width: 196px;
		height: 40px;
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 20px;
	}

	.floatP {
		position: absolute;
		display: inline-block;
		top: 100px;
		left: 20px;
		width: 250px;
		height: 92px;
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		overflow: hidden;
		font-size: 10px;
		font-family: PingFangSC-Light, PingFang SC;
		font-weight: 300;
		color: #FFFFFF;
		line-height: 16px;
	}

	.floatDiv p {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.floatDash {
		cursor: pointer;
		display: flex;
	}

	.floatDash p:hover {
		opacity: 1 !important;
	}

	.setOpacity {
		opacity: 1;
	}

	.normalOpacity {
		opacity: 0.39;
	}

	>>>.el-carousel__indicators {
		display: none;
	}
</style>
